<section class="section about" id='about'>
    <div class="container">
        <div class="section-box">
            <div class="about-title" data-aos="fade-up">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> About me
                </h3>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <div class="about-description">
                        <p   data-aos="fade-up" data-aos-duration="1000">
                            In my   <span class="underline">  1 year as a developer</span>,I am committed to continuous learning and professional growth,
                            constantly training to enhance my skills. My experience spans front-end development with technologies such as
                 
                           <span class="underline"> JavaScript, Vue.js, TypeScript, Angular</span>, as well as <span class="underline">React</span>  through personal projects.
                        </p>

                        <p>I am adept at implementing system improvements, optimizing and standardizing responsive web applications, and covering continuous integration practices.
                            I actively contribute value to each project by suggesting and executing ideas that drive improvements and deliver user-focused, high-quality solutions.</p>


                        <p>Some of the technologies that I have trained and worked on include (but are not limited to):</p>
                        <ul class="skills-list" data-aos="fade-up">
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Vue.js </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Angular </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">HTML </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Primevue </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Nuxt.js </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">CSS </span></li>
                 
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">TypeScript </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">JavaScript </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Angular Primeng </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Mysql </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">React </span></li>
                            <!-- <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Bootstrap, Material </span></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-4 mt-md-0 text-center" data-aos="fade-up" data-aos-duration="1000">
                    <div class="about-img-container">
                        <img (click)='analyticsService.sendAnalyticEvent("click_image", "about", "image")'  width="300" height="300" src="assets/images/me/siva.jpeg" alt="Git User">
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
